<template>
  <div>
    <div>
      <div class="columns">
        <div class="column">
          <b-field
            id="company-name"
            :label="$t('kyc.company_name')"
          >
            <b-input
              v-validate="'required'"
              v-model="form.orgCompanyName"
              :placeholder="$t('kyc.company_placholder')"
              name="company name"
              expanded
              data-test="kyc-org-information--company-name-field"
              @blur="$emit('trackInputForm', { key: 'orgCompanyName', name: 'company name', page: 'Information' })"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company name') }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            id="tax-id"
            :label="$t('kyc.tax_id')"
          >
            <b-input
              v-validate="'required'"
              v-model="form.orgTaxId"
              :placeholder="$t('kyc.tax_id')"
              name="tax id"
              expanded
              data-test="kyc-org-information--org-tax-id-field"
              @blur="$emit('trackInputForm', { key: 'orgTaxId', name: 'tax id', page: 'Information' })"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('tax id') }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            id="company-address"
            :label="$t('kyc.company_address')"
          >
            <b-input
              v-validate="'required'"
              v-model="form.orgCompanyAddressLineOne"
              :placeholder="$t('kyc.company_address')"
              name="company address"
              expanded
              data-test="kyc-org-information--company-address-field"
              @blur="$emit('trackInputForm', { key: 'orgCompanyAddressLineOne', name: 'company address', page: 'Information' })"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company address') }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field :label="$t('kyc.company_address_line_2')">
            <b-input
              v-model="form.orgCompanyAddressLineTwo"
              :placeholder="$t('kyc.company_address_line_2')"
              expanded
              data-test="kyc-org-information--company-address-line-2-field"
              @blur="$emit('trackInputForm', { key: 'orgCompanyAddressLineTwo', name: 'orgCompanyAddressLineTwo', page: 'Information' })"
            />
          </b-field>
        </div>
      </div>
      <div class="columns dp-flex">
        <div class="column">
          <b-field
            id="country"
            :label="$t('kyc.company_country')"
            class="kyc-information-is-expanded"
          >
            <b-select
              v-validate="'required'"
              v-model="form.orgCountry"
              :placeholder="$t('kyc.company_country')"
              name="organize country"
              data-test="kyc-org-information--org-country-field"
              @click.native="$emit('trackInputForm', { key: 'orgCountry', name: 'organize country', page: 'Information' })"
              @input="() => {
                form.orgCompanyProvince = null
                $forceUpdate()
              }"
            >
              <option
                v-for="(country, index) in countries"
                :value="country.en_short_name"
                :key="index"
                :disabled="country.disabled"
              >
                {{ country.en_short_name }}
              </option>
            </b-select>
          </b-field>
          <span class="is-invalid">{{ errors.first('organize country') }}</span>
        </div>
        <div class="column">
          <b-field
            id="company-postcode"
            :label="$t('kyc.company_zipcode')"
          >
            <ThailandAutoComplete
              v-validate="form.orgCountry === 'Thailand' ? 'required|numeric|length:5': 'required'"
              v-if="form.orgCountry === 'Thailand'"
              v-model="form.orgCompanyPostcode"
              :placeholder="$t('kyc.company_zipcode')"
              color="#337ab7"
              name="company postcode"
              type="zipcode"
              data-test="kyc-org-information--company-postcode-field"
              expanded
              @select="(address) => selectThailandAddrAutoComplete('company', address)"
              @blur="$emit('trackInputForm', { key: 'orgCompanyPostcode', name: 'company postcode', page: 'Information' })"
            />
            <b-input
              v-validate="form.orgCountry === 'Thailand' ? 'required|numeric|length:5': 'required'"
              v-else
              v-model="form.orgCompanyPostcode"
              :placeholder="$t('kyc.company_zipcode')"
              name="company postcode"
              expanded
              data-test="kyc-org-information--company-postcode-field"
              @blur="$emit('trackInputForm', { key: 'orgCompanyPostcode', name: 'company postcode', page: 'Information' })"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company postcode') }}</span>
        </div>
      </div>
      <div class="columns dp-flex">
        <div class="column">
          <b-field
            id="company-city"
            :label="$t('kyc.company_city')"
          >
            <ThailandAutoComplete
              v-validate="'required'"
              v-if="form.orgCountry === 'Thailand'"
              v-model="form.orgCompanyCity"
              :placeholder="$t('kyc.company_city')"
              color="#337ab7"
              name="company city"
              type="amphoe"
              data-test="kyc-org-information--company-city-field"
              expanded
              @select="(address) => selectThailandAddrAutoComplete('company', address)"
              @blur="$emit('trackInputForm', { key: 'orgCompanyCity', name: 'company city', page: 'Information' })"
            />
            <b-input
              v-validate="'required'"
              v-else
              v-model="form.orgCompanyCity"
              :placeholder="$t('kyc.company_city')"
              name="company city"
              expanded
              data-test="kyc-org-information--company-city-field"
              @blur="$emit('trackInputForm', { key: 'orgCompanyCity', name: 'company city', page: 'Information' })"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company city') }}</span>
        </div>
        <div class="column">
          <b-field
            id="company-province"
            :label="$t('kyc.company_province')"
          >
            <b-select
              v-validate="'required'"
              v-if="form.orgCountry === 'Thailand'"
              v-model="form.orgCompanyProvince"
              :placeholder="$t('kyc.company_province')"
              name="company province"
              expanded
              data-test="kyc-org-information--company-province-field"
              @blur="$emit('trackInputForm', { key: 'orgCompanyProvince', name: 'company province', page: 'Information' })"
              @input="clearAutoCompleteAddress('company')"
            >
              <option
                v-for="province in provincesInThailand"
                :value="province.key"
                :key="province.key"
              >
                {{ province.th }}
              </option>
            </b-select>
            <b-input
              v-validate="'required'"
              v-else
              v-model="form.orgCompanyProvince"
              :placeholder="$t('kyc.company_province')"
              name="company province"
              expanded
              data-test="kyc-org-information--company-province-field"
              @blur="$emit('trackInputForm', { key: 'orgCompanyProvince', name: 'company province', page: 'Information' })"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company province') }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            id="company-tel-number"
            :label="$t('kyc.company_tel_number')"
          >
            <b-input
              v-validate="'required'"
              v-model="form.orgTel"
              :placeholder="$t('kyc.company_tel_placeholder')"
              name="company phone number"
              autocomplete="disabled"
              data-test="kyc-org-information--phone-number-field"
              @blur="$emit('trackInputForm', { key: 'orgTel', name: 'company phone number', page: 'Information' })"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company phone number') }}</span>
        </div>
        <div class="column">
          <b-field
            id="businessType"
            :label="$t('kyc.business_type')"
            class="kyc-information-is-expanded"
          >
            <b-select
              v-validate="'required'"
              v-model="form.orgBusinessType"
              :placeholder="$t('kyc.business_type')"
              name="business type"
              data-test="kyc-org-information--business-type-field"
              @blur="$emit('trackInputForm', { key: 'orgBusinessType', name: 'business type', page: 'Information' })"
            >
              <option
                v-for="business in sortBusinessList"
                :value="business.key"
                :key="business.key"
                name="business type"
              >
                {{ business[$i18n.locale] }}
              </option>
            </b-select>
          </b-field>
          <span class="is-invalid">{{ errors.first('business type') }}</span>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            id="average-income"
            :label="$t('kyc.avg_income')"
            class="kyc-information-is-expanded"
          >
            <b-select
              v-validate="'required'"
              v-model="form.averageIncome"
              :placeholder="$t('kyc.avg_income')"
              name="average income"
              data-test="kyc-upload-doc-hight-risk--average-income-field"
            >
              <option
                v-for="income in averageIncomeList"
                :value="income.key"
                :key="income.key"
                name="income"
              >
                {{ income[$i18n.locale] }}
              </option>
            </b-select>
          </b-field>
          <span class="is-invalid">{{ errors.first('average income') }}</span>
        </div>
      </div>
      <UploadDocumentHightRisk
        v-if="businessLevel === 10"
        :form="form"
      />
    </div>
  </div>
</template>

<script>
import UploadDocumentHightRisk from '../UploadDocumentHightRisk'
import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import { sortDataByLanguage } from '@/utils/helper'

export default {
  name: 'OrgInformation',
  inject: ['$validator'],
  components: {
    UploadDocumentHightRisk,
    ThailandAutoComplete
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    countries: {
      type: Array,
      required: true
    },
    provincesInThailand: {
      type: Array,
      default: () => []
    },
    businessList: {
      type: Array,
      default: () => []
    },
    averageIncomeList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    businessLevel () {
      const result = this.businessList.find(val => this.form.orgBusinessType === val.key)
      return result && result.riskLevel
    },
    sortBusinessList () {
      return sortDataByLanguage(this.businessList, this.$i18n.locale)
    }
  },
  async created () {
    if (this.form.nationality && !this.form.orgCountry) {
      const defaultCountry = this.countries.find(c => c.nationality === this.form.nationality)
      if (defaultCountry) {
        this.form.orgCountry = defaultCountry['en_short_name']
      }
    }
  },
  beforeDestroy () {
    this.$validator.pause()
  },
  methods: {
    selectThailandAddrAutoComplete (type, address) {
      if (type === 'company') {
        this.form.orgCompanyPostcode = address.zipcode
        this.form.orgCompanyCity = address.amphoe
        this.form.orgCompanyProvince = this.provincesInThailand.find(p => p.th === address.province).key
      }
    },
    clearAutoCompleteAddress (type) {
      if (type === 'company') {
        this.form.orgCompanyPostcode = ''
        this.form.orgCompanyCity = ''
      }
    }
  }
}
</script>

<style lang="scss">
.kyc-information-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/Organization/Information.vue